<div
  class="component-container"
  data-cy="won_message"
  [style.backgroundColor]="
    config().backgroundColorBySubType?.[subType()] ?? config().backgroundColor
  "
>
  <p
    class="message"
    [style]="{
      color: config().message.color,
      fontFamily: config().message.fontFamily,
    }"
  >
    <span class="first-line">{{ config().message.firstLine }}</span>
    <span class="second-line">{{ config().message.secondLine }}</span>
  </p>

  <b2c-reward-sticker
    class="reward"
    [amount]="amount()"
    [imageUrl]="config().reward.imageUrl"
    [amountColor]="config().reward.amountColor"
    [amountFontFamily]="config().reward.amountFontFamily"
    [alternativeText]="config().reward.alternativeText | replaceVars: amount()"
  />
</div>
